// feature/carpetas-proceso — Phase 1. Dedup indicator on case detail:
// when this case's proceso (digit-normalized radicado) already has one
// or more carpetas billed, show a one-line banner so the carpetas team
// stops billing the same proceso twice. Click expands inline to show
// every sibling carpeta with a link back to its case.
//
// Styling deliberately reuses the warn-inline + glass-section pattern
// from the X2 impugnación banner — no new visual primitive.
import React, { useState } from "react";

const fmtDate = (d) => d ? new Date(d).toLocaleDateString("es-CO") : "—";

export default function ProcesoCarpetasBanner({ procesoCarpetas, onOpenCase }) {
  const [expanded, setExpanded] = useState(false);
  const list = Array.isArray(procesoCarpetas) ? procesoCarpetas : [];
  if (!list.length) return null;

  const first = list[0];
  const others = list.length - 1;
  const summary = others > 0
    ? <>Ya tiene carpeta — hecha por <strong>{first.hecha_por_name || "—"}</strong> el <strong>{fmtDate(first.hecha_at)}</strong>. Otras {others} en este proceso.</>
    : <>Ya tiene carpeta — hecha por <strong>{first.hecha_por_name || "—"}</strong> el <strong>{fmtDate(first.hecha_at)}</strong>.</>;

  return (
    <div className="warn-inline" style={{
      marginBottom: 16, padding: 12,
      background: "var(--color-info-bg)",
      borderColor: "var(--accent-mint)",
      color: "var(--text-body)",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: 18 }}>📁</span>
        <div style={{ flex: 1 }}>{summary}</div>
        <button
          className="ghost sm"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? "Ocultar" : "Ver detalle"}
        </button>
      </div>
      {expanded && (
        <div style={{ marginTop: 10, borderTop: "1px solid var(--border-hairline)", paddingTop: 10 }}>
          <table style={{ width: "100%", fontSize: 12 }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left" }}>N°</th>
                <th style={{ textAlign: "left" }}>Caso</th>
                <th style={{ textAlign: "left" }}>Hecha por</th>
                <th style={{ textAlign: "left" }}>Fecha</th>
              </tr>
            </thead>
            <tbody>
              {list.map((row) => (
                <tr key={`${row.case_id}-${row.numero}`}>
                  <td><strong>{row.numero}</strong></td>
                  <td>
                    {onOpenCase ? (
                      <button
                        className="link"
                        style={{
                          background: "none", border: 0, padding: 0,
                          color: "var(--accent-mint)",
                          cursor: "pointer", textDecoration: "underline",
                        }}
                        onClick={() => onOpenCase(row.case_id)}
                      >
                        {row.case_number}
                      </button>
                    ) : row.case_number}
                  </td>
                  <td>{row.hecha_por_name || "—"}</td>
                  <td>{fmtDate(row.hecha_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
